import { createStore } from 'vuex';
import helper from './modules/helper';
import page from './modules/page';
import user from './modules/user';
import modal from './modules/modal';
import cart from './modules/cart';
import payment from './modules/payment';
import orderhistory from './modules/orderhistory';

export default createStore({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    helper,
    page,
    user,
    modal,
    cart,
    payment,
    orderhistory,
  },
});
